import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import PreviewFrame from '../PreviewFrame';
import EditableBlock from '../EditableBlock';
import EditableText from '../EditableText';
import ImagePreview from '../ImagePreview';
import SplashCard from '../SplashCard';

import { IMAGE_EDITOR_FIELDS, TEXT_EDITOR_FIELDS } from '../../const';

const LandingPreview = ({ devicePreview, editable, selectedLanguage, languageOptions, setLanguageOptions, landing, onUpdateLandingBlock, imageInfo, onUpdateImageBlock }) => {
  const theme = useTheme();

  const isMobile = devicePreview === 'mobile';

  return (
    <PreviewFrame
      devicePreview={devicePreview}
      languageOptions={languageOptions}
      setLanguageOptions={setLanguageOptions}
      selectedLanguage={selectedLanguage}
      editable={editable}
      imageInfo={imageInfo}
      onUpdateImageBlock={onUpdateImageBlock}
    >
      <SplashCard isMobile={isMobile} maxWidth={470}>
        {/* Title */}
        {!!landing['title.success']?.show && (
          <EditableBlock
            editable={editable}
            editorTitle="Title"
            editorFields={TEXT_EDITOR_FIELDS}
            style={landing['title.success'].style}
            onStyleChange={style => onUpdateLandingBlock('title.success', { style })}
            blockSx={{ alignSelf: 'center', width: '100%' }}
          >
            <EditableText
              value={landing['title.success']?.text}
              editable={editable}
              onChange={html =>
                onUpdateLandingBlock('title.success', {
                  text: html,
                })
              }
              component="div"
              sx={{
                textAlign: 'center',
                fontSize: `${landing['title.success'].style.fontSize}px`,
                fontFamily: landing['title.success'].style.fontFamily,
                color: landing['title.success'].style.fontColor,
                fontWeight: theme.typography.customFontWeight[1],
                padding: '6px 0px',
                lineHeight: 1.5,
                outlineStyle: 'none',
              }}
            />
          </EditableBlock>
        )}

        {/* Subtitle */}
        {!!landing['subtitle.success']?.show && (
          <EditableBlock
            editable={editable}
            editorTitle="Subtitle"
            editorFields={TEXT_EDITOR_FIELDS}
            style={landing['subtitle.success'].style}
            onStyleChange={style => onUpdateLandingBlock('subtitle.success', { style })}
            blockSx={{ width: '100%' }}
          >
            <Box>
              <EditableText
                value={landing['subtitle.success']?.text}
                editable={editable}
                onChange={html =>
                  onUpdateLandingBlock('subtitle.success', {
                    text: html,
                  })
                }
                component="div"
                sx={{
                  textAlign: 'center',
                  fontSize: `${landing['subtitle.success'].style.fontSize}px`,
                  fontFamily: landing['subtitle.success'].style.fontFamily,
                  color: landing['subtitle.success'].style.fontColor,
                  padding: '6px 0px',
                  lineHeight: 1.5,
                  outlineStyle: 'none',
                }}
              />
            </Box>
          </EditableBlock>
        )}

        {/* Success Icon */}
        {!!imageInfo?.['success.icon']?.show && (
          <EditableBlock
            editable={editable}
            editorTitle="Success Icon"
            editorFields={IMAGE_EDITOR_FIELDS}
            style={imageInfo?.['success.icon']?.style}
            onStyleChange={style => onUpdateImageBlock('success.icon', { style })}
            onClearIconClick={() => onUpdateImageBlock('success.icon', { style: {}, content: '' })}
            showClearIcon={!!imageInfo?.['success.icon']?.style?.content}
            blockSx={{ width: '100%', display: 'flex', justifyContent: 'center' }}
          >
            {imageInfo?.['success.icon']?.style?.content ? (
              <ImagePreview alt="Success Icon" style={{ width: '100px', height: 'auto' }} base64={imageInfo?.['success.icon']?.style?.content} />
            ) : (
              <Box style={{ width: '150px', height: '40px' }} />
            )}
          </EditableBlock>
        )}

        {/* Text */}
        {!!landing['text.login.success']?.show && (
          <EditableBlock
            editable={editable}
            editorTitle="Text"
            editorFields={TEXT_EDITOR_FIELDS}
            style={landing['text.login.success'].style}
            onStyleChange={style => onUpdateLandingBlock('text.login.success', { style })}
            blockSx={{ width: '100%' }}
          >
            <Box>
              <EditableText
                value={landing['text.login.success']?.text}
                editable={editable}
                onChange={html =>
                  onUpdateLandingBlock('text.login.success', {
                    text: html,
                  })
                }
                component="div"
                sx={{
                  textAlign: 'center',
                  fontSize: `${landing['text.login.success'].style.fontSize}px`,
                  fontFamily: landing['text.login.success'].style.fontFamily,
                  color: landing['text.login.success'].style.fontColor,
                  padding: '6px 0px',
                  lineHeight: 1.5,
                  outlineStyle: 'none',
                }}
              />
            </Box>
          </EditableBlock>
        )}
      </SplashCard>
    </PreviewFrame>
  );
};

export default LandingPreview;
